import React, { memo } from 'react';
import { PaginationTemplate } from '../../components/templates';
import services from '../../services';
import EmpresasItem from './_components/EmpresasItem';
import EmpresasTerms from './_components/EmpresasTerms';
import { resolveEmpresasListSort, sanitizeEmpresasListParams } from './_shared/empresasFilterQuery';

/** Lista todas as empresas sem impor um setor. */
const Empresas = memo(() => {
  /** Aplica o contrato da listagem antes de consultar o serviço. */
  function pvList(pParams, pResolve, pReject, pFinally) {
    const xParams = sanitizeEmpresasListParams(pParams);

    xParams.sort = resolveEmpresasListSort(xParams.sort, Boolean(xParams.pesquisa));

    return services.pesquisas.pessoa(xParams, pResolve, pReject, pFinally);
  }

  return (
    <PaginationTemplate
      id="empresas"
      title="Empresas"
      description="Lista das empresas. Conheça o patrimônio líquido, capital social, balanço, ativos relacionados, filiais e participação societária."
      dataRead={pvList}
      dataReadParams={{ cancelado: 'null' }}
      termsComponent={EmpresasTerms}
      listItem={EmpresasItem}
      listItemKey="pessoa_id"
      listItemProps={{ pathnameBase: '/empresas' }}
      pageSize={25}
      match="empresas/busca/*"
      maxWidth="xl"
    />
  );
});

Empresas.displayName = 'Empresas';

export default Empresas;
